<section
  class="Feedback__Button"
  [ngClass]="{ Feedback__ButtonOpen: showFlyout }"
>
  <p class="Feedback__ButtonText" (click)="openFlyout()">
    {{ config?.feedbackText || 'Feedback' }}
  </p>
</section>

<section class="Feedback">
  <modal
    [config]="config.modalConfig"
    [condition]="!!showFlyout"
    (cancel)="closeFlyout()"
  >
    @if (config && !showNextStep) {
      <ng-container body>
        <section class="Feedback__Description">
          <div [innerHTML]="config.feedbackBodyText"></div>
        </section>
        <feedback-rating
          [ratingTitle]="config.ratingText"
          (ratings)="ratingUpdated($event)"
        ></feedback-rating>
        @if (config?.feedbackForm?.controls) {
          <section class="Feedback__Form">
            <form-group
              [configs]="config.feedbackForm.controls"
              [form]="feedbackForm"
              data-test-id="feedbackForm"
              direction="action"
            >
            </form-group>
          </section>
        }
      </ng-container>
    } @else {
      @if (showNextStep) {
        <ng-container body>
          <section class="Feedback__Description">
            <div [innerHTML]="config.feedbackBodyText"></div>
          </section>
        </ng-container>
      }
    }
    <ng-container footer>
      @if (config.footer && !showNextStep) {
        <section class="Feedback__Footer">
          <zip-button
            [config]="config.footer.cancel"
            (zipButtonClicked)="closeFlyout()"
          ></zip-button>
          <zip-button
            [config]="config.footer.submit"
            [disabled]="!isFormValid"
            (zipButtonClicked)="submitForm()"
          ></zip-button>
        </section>
      }
      @if (showNextStep) {
        <section class="Feedback__Footer Feedback__FooterRight">
          <zip-button
            [config]="config.footer.close"
            (zipButtonClicked)="closeFlyout()"
          ></zip-button>
        </section>
      }
    </ng-container>
  </modal>
</section>
